import { action, observable, computed, makeObservable } from "mobx";
import { VariantCappedServiceTotal } from "./ServicePlanModels";

export default class VariantCappedServiceTotalModel {
  @observable response: VariantCappedServiceTotal[] = [];

  constructor() {
    makeObservable(this);
  }

  @computed get length() {
    return this.response ? this.response.length : 0;
  }

  @action reset = () => {
    this.response = null;
  };
}
